<div class="container">
  <br />
  <div class="row">
    <div class="col-lg-5 col-md-7 mx-auto my-auto">
      <div class="card">
        <div class="card-body px-lg-5 py-lg-5 text-center">
          <img
            src="https://bootdey.com/img/Content/avatar/avatar7.png"
            class="rounded-circle avatar-lg img-thumbnail mb-4"
            alt="profile-image"
          />
          <h2 class="text-info">كود التحقق</h2>
          <p class="mb-4">ادخل كود التحقق المكون من 6 ارقام</p>
          <form [formGroup]="form">
            <div class="row mb-4">
              <div class="col-lg-2 col-md-2 col-2 ps-0 ps-md-2">
                <input
                  #input1
                  formControlName="code1"
                  type="text"
                  maxlength="1"
                  class="form-control text-lg text-center"
                  placeholder="_"
                  aria-label="2fa"
                  [appAutoTab]="input2"
                />
              </div>
              <div class="col-lg-2 col-md-2 col-2 ps-0 ps-md-2">
                <input
                  #input2
                  formControlName="code2"
                  id="tab2"
                  type="text"
                  maxlength="1"
                  class="form-control text-lg text-center"
                  placeholder="_"
                  aria-label="2fa"
                  [appAutoTab]="input3"
                />
              </div>
              <div class="col-lg-2 col-md-2 col-2 pe-0 pe-md-2">
                <input
                  #input3
                  formControlName="code3"
                  type="text"
                  maxlength="1"
                  class="form-control text-lg text-center"
                  placeholder="_"
                  aria-label="2fa"
                  [appAutoTab]="input4"
                />
              </div>
              <div class="col-lg-2 col-md-2 col-2 pe-0 pe-md-2">
                <input
                  #input4
                  formControlName="code4"
                  type="text"
                  maxlength="1"
                  class="form-control text-lg text-center"
                  placeholder="_"
                  aria-label="2fa"
                  [appAutoTab]="input5"
                />
              </div>
              <div class="col-lg-2 col-md-2 col-2 pe-0 pe-md-2">
                <input
                  #input5
                  formControlName="code5"
                  type="text"
                  maxlength="1"
                  class="form-control text-lg text-center"
                  placeholder="_"
                  aria-label="2fa"
                  [appAutoTab]="input6"
                />
              </div>
              <div class="col-lg-2 col-md-2 col-2 pe-0 pe-md-2">
                <input
                  #input6
                  formControlName="code6"
                  type="text"
                  maxlength="1"
                  class="form-control text-lg text-center"
                  placeholder="_"
                  aria-label="2fa"
                />
              </div>
            </div>
            <div class="text-center">
              <button
                type="button"
                class="btn bg-info btn-lg my-4"
                (click)="checklogin()"
              >
                تحقق
              </button>
            </div>

            <div class="mb-4" *ngIf="errorMessage">
              <ngb-alert type="danger" (close)="errorMessage = null">
                {{ errorMessage }}
              </ngb-alert>
            </div>
            
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
